import * as React from "react";

import "./src/normalize.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import "./src/scss/main.scss";


export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
    </>
  )
};
// Scroll to top on route change
// This is a workaround for the issue where Gatsby 
// does not scroll to the top of the page on route 
// change due to the page content not being loaded yet.
// NOTE: This function will be called on every route change
export const onRouteUpdate = (args) => {
  requestAnimationFrame(() => {
    // Prevent scrolling to top if the hash is #footer
    // This is to prevent the page from scrolling to the top
    // when the user clicks on the subscribe button
    if (
      args && 
      args.location && 
      args.location.hash && 
      args.location.hash === "#footer") {
      return;
    }
    window.scrollTo(0, 0);
  });
};